import React from "react";
import { usePageTitle } from "@/lib/usePageTitle";

const SECTIONS = [
  ["1. About these terms", "These terms govern your use of Olivia Does and the booking of home services through our platform. By creating an account or booking a job you agree to them."],
  ["2. Our service", "Olivia Does is a managed home-services concierge. Jobs are fulfilled either by our in-house team or by vetted partner tradespeople in our network. We coordinate the work and hold one standard across every visit."],
  ["3. Bookings & quotes", "Instant services are charged at the fixed price shown at booking. Quote-based work is confirmed in writing before any work begins. Prices are inclusive of VAT where applicable."],
  ["4. Payments", "Payment is held securely and released to the tradesperson after the work is completed and approved. A deposit may be required to confirm scheduling for larger jobs."],
  ["5. Cancellations & rescheduling", "You may cancel or request a new date from your dashboard. Cancellations made close to a scheduled visit may incur a fee to cover the partner's reserved time."],
  ["6. Our standard & aftercare", "Every partner is vetted, insured and quality-reviewed. If something isn't right, contact us and we'll make it right in line with our aftercare promise."],
  ["7. Liability", "Our partners carry their own public liability insurance. Olivia Does coordinates the service and is not liable for indirect or consequential loss beyond the value of the job."],
  ["8. Contact", "Questions about these terms? Email hello@oliviadoes.co.uk."],
];

export default function Terms() {
  usePageTitle("Terms of Service — Olivia Does");
  return (
    <section className="od-section od-wrap" style={{ maxWidth: 760 }} data-testid="terms-page">
      <div className="od-eyebrow">Legal</div>
      <h1 className="serif" style={{ fontSize: "2.3rem", fontWeight: 500, margin: "0 0 8px" }}>Terms of Service</h1>
      <p style={{ color: "var(--taupe)", marginBottom: 30 }}>Last updated June 2026.</p>
      {SECTIONS.map(([h, b]) => (
        <div key={h} style={{ marginBottom: 24 }}>
          <h3 className="serif" style={{ fontWeight: 500, marginBottom: 6 }}>{h}</h3>
          <p style={{ color: "var(--taupe)", lineHeight: 1.7 }}>{b}</p>
        </div>
      ))}
    </section>
  );
}
